var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ord-tab"},[_c('OrdersTableComponent',{ref:"table",on:{"order-cancelled":function($event){return _vm.$emit('order-cancelled')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }